// Shared default used for both customer booking cutoff and daily next-day email send time.
export const DEFAULT_NEXT_DAY_BOOKING_CUTOFF_TIME = '23:30'
